import ResetPasswordForm from '../../components/auth/forms/ResetPasswordForm'

const ResetPasswordPage = () => {
  return (
    <div>
      <ResetPasswordForm/>
    </div>
  )
}

export default ResetPasswordPage
